import { Link } from "react-router-dom";
import { ArrowUpRight, Award, ShieldCheck, GraduationCap, Users } from "lucide-react";
import SectionLabel from "@/components/SectionLabel";
import usePageMeta from "@/hooks/usePageMeta";

export default function EvcVigor() {
  usePageMeta({
    title: "EVC Centrum VIGOR, Partner LevelLeven",
    description: "EVC Centrum VIGOR, onze partner voor Erkenning van Verworven Competenties en startkwalificaties.",
  });
  return (
    <div>
      <section className="py-16 sm:py-24">
        <div className="max-w-[1200px] mx-auto px-6 sm:px-10 lg:px-16">
          <div className="max-w-3xl reveal">
            <SectionLabel>Partner · EVC-trajecten</SectionLabel>
            <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-[#1D2A22] font-light">
              EVC Centrum <span className="italic text-[#E06B3F]">VIGOR</span>
            </h1>
            <p className="mt-6 text-[#7A8276] italic">
              Onze partner voor startkwalificaties via Erkenning van Verworven Competenties.
            </p>
            <p className="mt-8 text-lg text-[#4A5D4E] leading-relaxed font-light">
              VIGOR is een geaccrediteerd EVC-centrum dat de competenties van
              mensen, verworven via werk, vrijwilligerswerk, mantelzorg of
              levenservaring, formeel beoordeelt en erkent. Wat iemand al kan,
              wordt zichtbaar én officieel vastgelegd volgens de landelijke
              standaard.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-[#EFECE5]">
        <div className="max-w-[1200px] mx-auto px-6 sm:px-10 lg:px-16">
          <SectionLabel>Wat VIGOR doet</SectionLabel>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
            {[
              { icon: Award, t: "Ervaringscertificaten", d: "Formele erkenning van competenties op MBO-niveau, direct te gebruiken bij werkgevers en opleidingen." },
              { icon: GraduationCap, t: "Startkwalificaties", d: "Waar mogelijk vertaling naar een startkwalificatie MBO-2 die aansluit op de arbeidsmarkt." },
              { icon: ShieldCheck, t: "Geaccrediteerd", d: "Werkt volgens de landelijke EVC-standaard en de kwaliteitseisen van het Nationaal Kenniscentrum EVC." },
              { icon: Users, t: "Persoonlijke begeleiding", d: "Ervaren EVC-assessoren die deelnemers stap voor stap door het beoordelingstraject leiden." },
            ].map((x) => {
              const Icon = x.icon;
              return (
                <div key={x.t} className="bg-[#FAF7F1] rounded-2xl border border-[#E5E1D8] p-6">
                  <Icon size={20} className="text-[#E06B3F] mb-4" />
                  <p className="font-heading text-2xl text-[#1D2A22] leading-tight">{x.t}</p>
                  <p className="mt-3 text-[#4A5D4E] leading-relaxed font-light">{x.d}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24">
        <div className="max-w-[1200px] mx-auto px-6 sm:px-10 lg:px-16">
          <SectionLabel>Hoe wij samenwerken</SectionLabel>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mt-6">
            <div className="md:col-span-5">
              <h2 className="font-heading text-3xl text-[#1D2A22] leading-tight font-light">
                LevelLeven bouwt fundament, VIGOR maakt het{" "}
                <span className="italic text-[#E06B3F]">papierbaar</span>.
              </h2>
            </div>
            <div className="md:col-span-7 text-[#4A5D4E] leading-relaxed font-light space-y-4">
              <p>
                Tijdens LevelLeven (START, en waar nodig VERDER) werken deelnemers aan
                gedragsverandering, structuur en participatie. Parallel, vanaf
                het moment dat een deelnemer eraan toe is, begeleidt VIGOR het
                EVC-traject.
              </p>
              <p>
                Aan het einde van het jaar verlaat de deelnemer het programma
                met een formeel ervaringscertificaat en, waar mogelijk, een
                startkwalificatie. Dat versterkt zowel de uitstroom naar werk
                als de doorstroom naar opleiding.
              </p>
            </div>
          </div>
          <div className="mt-12 flex flex-wrap gap-4">
            <Link
              to="/startkwalificaties"
              className="group inline-flex items-center gap-3 bg-[#1D2A22] hover:bg-[#E06B3F] text-[#FAF7F1] rounded-full pl-6 pr-2 py-2 transition-colors text-sm"
            >
              <span>Meer over startkwalificaties</span>
              <span className="bg-[#E06B3F] group-hover:bg-[#FAF7F1] group-hover:text-[#1D2A22] text-white w-8 h-8 rounded-full flex items-center justify-center transition-colors">
                <ArrowUpRight size={14} />
              </span>
            </Link>
            <Link
              to="/partners"
              className="inline-flex items-center gap-2 rounded-full border border-[#1D2A22] text-[#1D2A22] hover:bg-[#1D2A22] hover:text-[#FAF7F1] px-6 py-2 text-sm transition-colors"
            >
              Alle partners
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
